import { h } from 'preact'
import Icon from '../assets'
import TextButton from '../../control-components/ui-components/TextButton'
import PreviewService from '../../services/previewService'
import { ContentType } from '../utils/contentType'

interface Props {
  topicId: number,
  isPublic: boolean,
  onShowPreviewModal: () => void,
  onError: () => void,
  onSuccess: (message: string) => void,
  type: ContentType
}

const displayMessage = {
  isPrivate: 'Only people with moderator role or above can preview via the link',
  isPublic: 'Anyone who has the preview link can access the preview without signing in'
}
const PreviewSettings = (props: Props) => {
  async function onPreviewInCommunity () {
    const link = await PreviewService.generatePreviewUrl(props.topicId, props.type)
    window.open(link)
  }

  async function onCopyLink () {
    const link = await PreviewService.generatePreviewUrl(props.topicId, props.type)
    const tmp = document.createElement('textarea')
    tmp.value = link
    document.body.appendChild(tmp)
    tmp.select()
    document.execCommand('copy')
    document.body.removeChild(tmp)
    props.onSuccess('Preview link copied!')
  }

  return (
    <div className='topic-creator__preview'>
      <div className='topic-creator__preview-manage'>
        <div className='topic-creator__preview-in-community'>
          <a className='qa-preview-in-community' onClick={onPreviewInCommunity}><span>Preview in community</span>&nbsp;<Icon icon='squareDiagonalArrow' width={9} height={9} /></a>
        </div>
        <div className='topic-creator__copy-link'>
          <a className='qa-preview-copy-link' onClick={onCopyLink}>Copy link</a>
        </div>
      </div>
      <div className='topic-creator__preview-display'>
        <div className='topic-creator__preview-display-icon'><Icon icon='people' width={16} height={16} /></div>
        <div className='topic-creator__preview-display-message'>{props.isPublic ? displayMessage.isPublic : displayMessage.isPrivate}
            &nbsp;(<TextButton class='topic-creator__change-preview-button' onClick={props.onShowPreviewModal}>change</TextButton>)
        </div>
      </div>
    </div>
  )
}

export default PreviewSettings
